module.exports = __webpack_public_path__ + "static/img/recall-share-popup.388ac1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/midAutumnRecall/recall/recall-share-popup.png
// module id = dPzr
// module chunks = 1